import { render, staticRenderFns } from "./edit-password-card.vue?vue&type=template&id=e4b858a2"
import script from "./edit-password-card.vue?vue&type=script&lang=js"
export * from "./edit-password-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports